// import React, { useState } from "react";
// import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
// import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
// import FileUploader from "../../../components/Elements/FileUploader/FileUploader";
// import CustomButton from "../../../components/Elements/Buttons/CustomButtons";

// const ManualReportPop = ({ open, onCancel }) => {
//   const [uploadedFiles, setUploadedFiles] = useState([]);

//   return (
//     <div>
//       <DailogBox open={open} onCancel={onCancel} width={700}>
//         <div className="flex items-center  gap-2 text-xl  font-bold">
//           <TextStyles color="gradient">Manual Generate Report</TextStyles>
//         </div>
//         <div className="border border-solid border-grey-500 rounded-lg">
//           {/*Use a Component to Upload File and show the file Name and button to view and delete those Files */}
//           <FileUploader files={uploadedFiles} setFiles={setUploadedFiles} />
//         </div>
//         <div className="flex justify-center gap-6 p-5">
//           <CustomButton
//             buttonType="button"
//             variant="cancel"
//             buttonText="Cancel"
//             onClick={onCancel}
//             // onClick={handleCancel}
//             className="text-base font-normal h-[50px] px-8"
//           />

//           <CustomButton
//             buttonType="button"
//             variant="ok"
//             buttonText="Sent for Approval"
//             onClick={onCancel}
//             className="text-base font-normal h-[50px] px-8"
//           />
//         </div>
//       </DailogBox>
//     </div>
//   );
// };

// export default ManualReportPop;

import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import FileUploader from "../../../components/Elements/FileUploader/FileUploader";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { useLocation } from "react-router-dom";
import { postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
const ManualReportPop = ({ open, onCancel, onSuccess }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, duration);
  };

  // Get reportId from location state
  const { reportId } = location.state || {};

  console.log("Report ID:", reportId);

  // Handle submit
  const handleSubmit = async () => {
    if (!reportId) {
      triggerPopup("Error","Report ID is missing!");
      return;
    }

    if (uploadedFiles.length === 0) {
      triggerPopup("Error","Please upload at least one file!");
      return;
    }

    setLoading(true);
    try {
      // Create FormData to send files
      const formData = new FormData();

      // Append all uploaded files
      uploadedFiles.forEach((file, index) => {
        formData.append('pdfs', file); // Backend expects 'pdfs' as the key
      });

      // Make API call
      const response = await postApi({
        apiUrl: API_URLS.CREATE_REPORT_REQUEST(reportId),
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log("Upload Response:", response);

      if (response?.success) {
        triggerPopup("Success"," Report sent for approval successfully!");
        setUploadedFiles([]); // Clear files
        onCancel(); // Close modal
        if (onSuccess) {
          onSuccess(); // Refresh parent component data
        }
      } else {
        triggerPopup(response?.message || "Failed to send report for approval");
      }
    } catch (error) {
      console.error("Error uploading report:", error);
      triggerPopup("Failed to upload report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel
  const handleCancel = () => {
    setUploadedFiles([]);
    onCancel();
  };

  return (
    <div>
      <DailogBox open={open} onCancel={handleCancel} width={700}>
        <div className="flex items-center gap-2 text-xl font-bold">
          <TextStyles color="gradient">Manual Generate Report</TextStyles>
        </div>

        <div className="border border-solid border-grey-500 rounded-lg">
          {/* Use a Component to Upload File and show the file Name and button to view and delete those Files */}
          <FileUploader files={uploadedFiles} setFiles={setUploadedFiles} />
        </div>

        {/* Show file count */}
        {uploadedFiles.length > 0 && (
          <div className="text-sm text-gray-600 mt-2">
            {uploadedFiles.length} file(s) selected
          </div>
        )}

        <div className="flex justify-center gap-6 p-5">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={handleCancel}
            className="text-base font-normal h-[50px] px-8"
            disabled={loading}
          />

          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText={loading ? "Uploading..." : "Sent for Approval"}
            onClick={handleSubmit}
            className="text-base font-normal h-[50px] px-8"
            disabled={loading || uploadedFiles.length === 0}
          />
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DailogBox>
    </div>
  );
};

export default ManualReportPop;